<template>
  <div>
    <v-dialog v-model="showDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('bot_profile') }}</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <BotProfile @onSelectAvatar="handleSelectAvatar" />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" outline @click="showDialog = false">
            {{ $t('cancel') }}
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BotProfile from './BotProfile.vue'
export default {
  components: {
    BotProfile
  },
  props: ['value'],
  data() {
    return {
      showDialog: this.value
    }
  },
  watch: {
    value() {
      this.showDialog = this.value
    },
    showDialog() {
      this.$emit('input', this.showDialog)
    }
  },
  methods: {
    handleSelectAvatar(payload) {
      this.$emit('onSelectAvatar', payload)
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/BotProfile/DialogBotProfile.vue